<template>
  <div class="container-fluid">
    <reseller-payment-form
      :loading="loading"
      :resellerPaymentData="resellerPayment"
      :formErrors="formErrors"
      @resellerPaymentSubmitted="handleSubmit"
      @formChanged="() => (alertLeave = true)"
    />
  </div>
</template>

<script>
import { Select, Option } from "element-ui";
import { cloneDeep } from "lodash";
import alertLeave from "@/mixins/alert-leave-mixin";
import defaultResellerPayment from "../defaultResellerPayment";
import ResellerPaymentForm from "../partials/ResellerPaymentForm.vue";

export default {
  layout: "DashboardLayout",

  components: {
    [Select.name]: Select,
    [Option.name]: Option,
    ResellerPaymentForm,
  },

  mixins: [alertLeave],

  data() {
    return {
      resellerPayment: cloneDeep(defaultResellerPayment),
      formErrors: null,
      loading: false,
    };
  },

  created() {},

  methods: {
    async handleSubmit(resellerPayment) {
      this.loading = true;
      const resellerPaymentData = cloneDeep(resellerPayment);
      delete resellerPaymentData.id;

      try {
        await this.$store.dispatch("resellerPayments/add", resellerPaymentData);
        this.$notify({
          type: "success",
          message: this.$t("RESELLER_PAYMENTS.RESELLER_PAYMENT_ADDED"),
        });
        const resellerPayment = await this.$store.getters[
          "resellerPayments/resellerPayment"
        ];
        this.$emit("onViewResellerPayment", resellerPayment, true);
        this.loading = false;
      } catch (error) {
        this.$notify({
          type: "danger",
          message: this.$t("ERRORS.SOMETHING_WENT_WRONG"),
        });
        this.formErrors = error.response.data.errors;
        this.loading = false;
      }
    },
  },
};
</script>
